import React, { useEffect, useState } from 'react'
import { Card, CardContent, Container, CircularProgress, Radio, TextField, Typography } from '@material-ui/core'
import { useStyles } from '../styles'
import { useDatabase } from '../DatabaseContext'
import { useAdDatabase } from '../AdDatabaseContext'

import ErrorCard from './ErrorCard'
import ContinueCard from './ContinueCard'

function QuestionCard({ id }) {

  const classes = useStyles()
  const { curUser, politicsQuestions, covidQuestions, startQuestionTime, receiveQuestionResponses } = useDatabase()

  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [question, setQuestion] = useState()
  const [answer, setAnswer] = useState('')
  const [emptyBlank, setEmptyBlank] = useState(false)
  const [selectedMessage, setSelectedMessage] = useState('')

  const handleRefresh = () => {
    setLoading(true)
    setError('')
    setAnswer('')
    setEmptyBlank(false)
    setSelectedMessage('')
    setQuestion(
      (curUser.instanceVersion % 2) ?
      { ...politicsQuestions[id], selectedOption: '' } :
      { ...covidQuestions[id], selectedOption: '' }
    )
    startQuestionTime(id).then(_ => {
      setLoading(false)
    }).catch(err => {
      setError('Some error occurred. Please try again.')
      setLoading(false)
    })
  }

  const chooseOption = (index) => {
    setSelectedMessage('')
    setEmptyBlank(false)
    setQuestion(q => {
      return { ...q, selectedOption: index }
    })
  }

  const handleSubmit = async () => {
    setSelectedMessage('')
    setEmptyBlank(false)
    if (question.selectedOption === '') {
      setSelectedMessage('Please select an option')
      return
    }
    let i = Number.parseInt(question.selectedOption)
    let selected = question.options[i]
    if ((selected === 'Other:' || selected === 'More:') && !answer) {
      setEmptyBlank(true)
      setSelectedMessage(question.emptyBlankError || 'Please enter something in the blank')
      return
    }
    let response = { selectedOption: i, answer: '' }
    if (selected !== 'Other:' && selected !== 'More:')
      response.answer = question.options[i]
    else
      response.answer = answer
    try {
      await receiveQuestionResponses(id, response)
    } catch (err) {
      throw err
    }
  }

  useEffect(() => {
    handleRefresh()
    // eslint-disable-next-line
  }, [id])

  return (
    <div className='QuestionCard' style={{ marginBottom: '90px' }}>
      <Container maxWidth='md'>
        {loading ?
          <div style={{ textAlign: 'center' }}><CircularProgress color='secondary' /></div> :
          error ?
            <ErrorCard message={error} action={handleRefresh} /> :
            question ?
              <>
                <Card elevation={2} className={classes.postCard}>
                  <CardContent>
                    <Typography variant='body1' paragraph>{question.question}</Typography>
                    {question.options.map((op, i) => (
                      <div key={i} style={{ textAlign: 'left', paddingLeft: 64 }}>
                        <Radio checked={question.selectedOption === `${i}`} onChange={e => chooseOption(`${i}`)} />
                        <Typography variant='body1' display='inline'
                          onClick={e => chooseOption(`${i}`)}
                          style={{ cursor: 'pointer' }}
                        >
                          {op}
                        </Typography>
                        {(op === 'Other:' || op === 'More:') &&
                          <TextField style={{ marginLeft: 20 }}
                            type={op === 'More:' ? 'number' : 'text'}
                            value={answer}
                            error={emptyBlank}
                            onChange={e => {
                              chooseOption(`${i}`)
                              setAnswer(e.target.value)
                            }}
                            onClick={e => chooseOption(`${i}`)}
                          />
                        }
                      </div>
                    ))}
                    {selectedMessage && <Typography variant='body2' color='error'>{selectedMessage}</Typography>}
                  </CardContent>
                </Card>

                <ContinueCard action={handleSubmit} />
              </> :
              <div style={{ textAlign: 'center' }}><CircularProgress color='secondary' /></div>
        }
      </Container>
    </div>
  )
}

export default React.memo(QuestionCard)
